import React from "react";
import { useParams } from "react-router-dom";
import ResiWebApp from "./ResiWebApp";

const ResiWebWrapper = () => {
  const { username } = useParams();

  return <ResiWebApp username={username} />;
};

export default ResiWebWrapper;
